import React from "react";
import { Typography } from "antd";
import { useIntl } from "react-intl";
import { getLocalPhoneNumber } from "../../../components/util/helpers";

const { Text, Title } = Typography;

const DetailsItem = (props) => {
  const { name, record, phone } = props;
  const intl = useIntl();
  return (
    <div className="details_item">
      <Text ellipsis>
        {intl.formatMessage({
          id: `app.forms.employee.${name}`,
        })}
      </Text>
      <Title level={5} ellipsis>
        {phone ? getLocalPhoneNumber(record[name]) : record[name]}
      </Title>
    </div>
  );
};

export default DetailsItem;
